/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DiscoverVersionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DiscoverVersionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DiscoverVersionSecurity = {
  option1?: DiscoverVersionSecurityOption1 | undefined;
  option2?: DiscoverVersionSecurityOption2 | undefined;
};

export type DiscoverVersionRequest = {
  includeDeleted?: boolean | undefined;
  /**
   * Unsupported: any supplied value returns 400
   */
  updatedSince?: string | undefined;
  serverName: string;
  version: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DiscoverVersionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DiscoverVersionSecurityOption1$outboundSchema: z.ZodMiniType<
  DiscoverVersionSecurityOption1$Outbound,
  DiscoverVersionSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function discoverVersionSecurityOption1ToJSON(
  discoverVersionSecurityOption1: DiscoverVersionSecurityOption1,
): string {
  return JSON.stringify(
    DiscoverVersionSecurityOption1$outboundSchema.parse(
      discoverVersionSecurityOption1,
    ),
  );
}

/** @internal */
export type DiscoverVersionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DiscoverVersionSecurityOption2$outboundSchema: z.ZodMiniType<
  DiscoverVersionSecurityOption2$Outbound,
  DiscoverVersionSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function discoverVersionSecurityOption2ToJSON(
  discoverVersionSecurityOption2: DiscoverVersionSecurityOption2,
): string {
  return JSON.stringify(
    DiscoverVersionSecurityOption2$outboundSchema.parse(
      discoverVersionSecurityOption2,
    ),
  );
}

/** @internal */
export type DiscoverVersionSecurity$Outbound = {
  Option1?: DiscoverVersionSecurityOption1$Outbound | undefined;
  Option2?: DiscoverVersionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DiscoverVersionSecurity$outboundSchema: z.ZodMiniType<
  DiscoverVersionSecurity$Outbound,
  DiscoverVersionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DiscoverVersionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DiscoverVersionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function discoverVersionSecurityToJSON(
  discoverVersionSecurity: DiscoverVersionSecurity,
): string {
  return JSON.stringify(
    DiscoverVersionSecurity$outboundSchema.parse(discoverVersionSecurity),
  );
}

/** @internal */
export type DiscoverVersionRequest$Outbound = {
  include_deleted: boolean;
  updated_since?: string | undefined;
  serverName: string;
  version: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DiscoverVersionRequest$outboundSchema: z.ZodMiniType<
  DiscoverVersionRequest$Outbound,
  DiscoverVersionRequest
> = z.pipe(
  z.object({
    includeDeleted: z._default(z.boolean(), false),
    updatedSince: z.optional(z.string()),
    serverName: z.string(),
    version: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      includeDeleted: "include_deleted",
      updatedSince: "updated_since",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function discoverVersionRequestToJSON(
  discoverVersionRequest: DiscoverVersionRequest,
): string {
  return JSON.stringify(
    DiscoverVersionRequest$outboundSchema.parse(discoverVersionRequest),
  );
}
